// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[type=file][data-v-21179eb5]{position:absolute;left:-99999px}.click[data-v-21179eb5]{cursor:pointer}.img[data-v-21179eb5]{max-width:100%;max-height:100%}.remove[data-v-21179eb5]{position:absolute;top:0;right:0}", ""]);
// Exports
module.exports = exports;
